import { I18n } from "../hooks/useTranslations";

const COST_CURRENCY_NOT_FOUND = 1700014;

export type CustomError = {
  json: {
    error: {
      status: number;
      message: string;
      error: number | null;
    };
  };
};

type MissingCurrencyPayload = {
  missingCurrency?: string;
};

export type MissingCurrencyError = {
  json: {
    error: {
      status: number;
      message: string;
      code: number;
      payload?: MissingCurrencyPayload;
    };
  };
};

export const isMissingCurrencyError = (error: any): error is MissingCurrencyError =>
  error?.json?.error?.code === COST_CURRENCY_NOT_FOUND;

export const getMissingCurrency = (error: MissingCurrencyError): string | undefined => {
  const payload = error.json.error.payload;
  return typeof payload?.missingCurrency === "string" ? payload.missingCurrency : undefined;
};

export const getErrorCode = (error: any): number | null => {
  // Try err.json.error.code (standard format)
  if (error?.json?.error?.code) {
    return error.json.error.code;
  }

  // Try err.error.code (alternative format)
  if (error?.error?.code) {
    return error.error.code;
  }

  // Try parsing JSON from error message (WretchError format)
  if (error?.message && typeof error.message === "string") {
    try {
      const parsed = JSON.parse(error.message);
      if (parsed?.error?.code) {
        return parsed.error.code;
      }
    } catch (e) {
      // Not JSON or invalid format, ignore
    }
  }

  return null;
};

export const getErrorMessage = (i18n: I18n, error: any): string => {
  const code = getErrorCode(error);
  if (code) {
    const msg = i18n.errorsMap.get(code);
    return msg ?? `${i18n.t.common.genericError} (${code})`;
  }
  return i18n.t.common.genericError;
};

export const isConflict = (error: any): boolean => error?.json?.error?.status === 409 || error?.status === 409;
